import logger from "./logger";

export interface ILocalStorage {
    get<T>(key: string): T | undefined;
    getAllWith<T>(query: string): T[];
    add<T>(key: string, data: T): void;
    remove(key: string): boolean;
    removeAllWith(query: string): boolean;
}

class BrowserStorage {
    get<T>(key: string) {
        let item = window.sessionStorage.getItem(key);
        if (item) {
            return JSON.parse(item) as T;
        }
        return undefined;
    }

    getAllWith<T>(query: string) {
        let resultSet: T[] = [];
        const queryLen = query.length;
        for (let key in window.sessionStorage) {
            if (key.slice(0, queryLen) === query) {
                let item = window.sessionStorage.getItem(key);
                if (item) {
                    resultSet.push(JSON.parse(item) as T);
                }
            }
        }

        return resultSet;
    }

    add<T>(key: string, data: T) {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }

    remove(key: string) {
        if (window.sessionStorage.getItem(key)) {
            window.sessionStorage.removeItem(key);
            return true;
        }
        return false;
    }

    removeAllWith(query: string) {
        let anyDeleted = false;
        const queryLen = query.length;
        for (let key in window.sessionStorage) {
            if (key.slice(0, queryLen) === query) {
                if (window.sessionStorage.getItem(key)) {
                    window.sessionStorage.removeItem(key);
                    anyDeleted = true;
                }
            }
        }

        return anyDeleted;
    }
}

export function getStorage(): ILocalStorage {
    if (window.hasOwnProperty("cordova")) {
        return new BrowserStorage();
    }
    return new BrowserStorage();
}

export function getSecureStorage() {
    try {
        if (cordova) {
            let ss = new cordova.plugins.SecureStorage(
                () => logger.info("Secure storage loaded"),
                (err: Error) => logger.error(err),
                "hypo-mobiilipankki"
            );
            return ss;
        }
    } catch (err) {
        logger.warn("Cannot load secure storage");
        return undefined;
    }
}

export function clearSecureStorage() {
    let secureStorage = getSecureStorage();
    if (secureStorage) {
        localStorage.clear();
        secureStorage.clear(
            function () {
                logger.info("cleared");
            },
            function (error: any) {
                logger.info("Error, " + error);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/util/storage.ts